/**
 * This SVG was copied from Material Symbols and is only included to maintain
 * visual consistency with our other icons for the "Insights Classic" icon.
 */
export const InsightsClassicIcon = () => (
  <svg
    fill="currentColor"
    height="1em"
    viewBox="0 -960 960 960"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M520-520h278q-15-110-91.5-186.5T520-798v278Zm-80 358v-636q-121 15-200.5 105.5T160-480q0 122 79.5 212.5T440-162Zm80 0q110-14 187-91t91-187H520v278Zm-40-318Zm0 400q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 155.5 31.5t127 86q54.5 54.5 86 127T880-480q0 82-31.5 155T763-197.5q-54 54.5-127 86T480-80Z" />
  </svg>
);
